jQuery( document ).ready(function() {
  var swiper = new Swiper(".mySwiper", {
  	// loop: true,
  	spaceBetween: 0,
  	effect: "fade",
  	// allowTouchMove: false,
  	slidesPerView: 1,
      speed: 700,
  	pagination: {
  		el: ".swiper-pagination",
  		type: "progressbar",
  	},
  	navigation: {
  		nextEl: ".swiper-button-next",
  		prevEl: ".swiper-button-prev",
  	},
      autoplay: {
          delay: 2500,
          disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          // allowTouchMove: true,
          // autoplay: false,
          // loop: false
        },
        768: {
          // allowTouchMove: false,
          // autoplay: true
        }
      }
  });
  var swiper2 = new Swiper(".mySwiper2", {
  	spaceBetween: 0,
  	// loop: true,
  	slidesPerView: 1,
    speed: 700,
  	thumbs: {
  		swiper: swiper,
  	},
    autoplay: {
          delay: 3000,
          disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          // autoplay: false,
          // loop: false
        },
        768: {
          // autoplay: true
        }
      }
  });


  swiper.on('slideChange', function (e) {
      console.log('*** mySwiper.activeIndex', swiper.activeIndex);
    // setTimeout(function(){
    swiper2.slideTo(swiper.activeIndex);
      // }, 100)
  });
});